import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import * as S from './ConfirmGolferNavigateModal.styles'

type Props = {
  isVisible: boolean
  onConfirmAndNavigate: () => void
  onNavigateWithoutConfirming: () => void
  onCancel: () => void
}

export const ConfirmGolferNavigateModal: React.FC<Props> = ({
  isVisible,
  onConfirmAndNavigate,
  onNavigateWithoutConfirming,
  onCancel,
}) => {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null)

  useEffect(() => {
    let element = document.getElementById('modal-root')
    if (!element) {
      element = document.createElement('div')
      element.id = 'modal-root'
      document.body.appendChild(element)
    }
    setPortalElement(element)

    return () => {
      if (element && !document.getElementById('modal-root')) {
        document.body.removeChild(element)
      }
    }
  }, [])

  if (!isVisible || !portalElement) return null

  return createPortal(
    <S.ModalBackdrop visible={isVisible}>
      <S.ModalContent>
        <S.ModalTitle>Unconfirmed changes</S.ModalTitle>
        <S.ModalDescription>
          You have unconfirmed changes for this golfer. Would you like to
          confirm them before navigating?
        </S.ModalDescription>
        <S.ButtonRow>
          <S.PrimaryButton
            onClick={onConfirmAndNavigate}
            data-testid="confirm-and-navigate"
          >
            Confirm and proceed
          </S.PrimaryButton>
          <S.SecondaryButton
            onClick={onNavigateWithoutConfirming}
            data-testid="navigate-without-confirming"
          >
            Proceed without confirming
          </S.SecondaryButton>
          <S.CancelButton onClick={onCancel} data-testid="cancel-navigate">
            Cancel
          </S.CancelButton>
        </S.ButtonRow>
      </S.ModalContent>
    </S.ModalBackdrop>,
    portalElement
  )
}

export default ConfirmGolferNavigateModal
